import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function E() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();

    const IMGS_MAP: any = {
        us: [
            {
                pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124993791/5_1.jpg',
                h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125006191/5_1_M.jpg',
            },
            {
                pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125021232/5_2.jpg',
                h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125032040/5_2_M.jpg',
            },
        ],
        eu: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544071589/roof_space1_pc_eu.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544394416/roof_space1_h5_eu.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544582839/roof_space2_pc_eu.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544482799/roof_space2_h5_eu.png',
            },
        ],
        uk: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544072446/roof_space1_pc_uk.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544394624/roof_space1_h5_uk.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544581796/roof_space2_pc_uk.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544482266/roof_space2_h5_uk.png',
            },
        ],
        de: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729239470081/roof_space1_pc_de.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729239469902/roof_space1_h5_de.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544581630/roof_space2_pc_de.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544072782/roof_space2_h5_de.png',
            },
        ],
        fr: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544071885/roof_space1_pc_fr.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544394919/roof_space1_h5_fr.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544582299/roof_space2_pc_fr.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544482435/roof_space2_h5_fr.png',
            },
        ],
        es: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1729569195671/ES-PC.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1729569237092/ES-M.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544582521/roof_space2_pc_es.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544482076/roof_space2_h5_es.png',
            },
        ],
        it: [
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544072131/roof_space1_pc_it.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544394114/roof_space1_h5_it.png',
            },
            {
                pc: 'https://websiteoss.ecoflow.com/upload/image/1728544582016/roof_space2_pc_it.png',
                h5: 'https://websiteoss.ecoflow.com/upload/image/1728544482621/roof_space2_h5_it.png',
            },
        ],
    };

    const IMGS = IMGS_MAP[locale] || IMGS_MAP.us;

    return (
        <div className={`sp-175w-E sp-175w-common ${css['sp-175w-E']}`}>
            <div className="info">
                <p className="subtitle">{t('E_subtitle')}</p>
                <p className="title">{t('E_title')}</p>
                <p className="desc">{t('E_desc')}</p>
            </div>
            <ul className="imgs">
                {[1, 2]?.map((img: any, k: number) => (
                    <li className={`img img-${k}`} key={k}>
                        <EFPicture src={IMGS[k].pc} srcPad={IMGS[k].h5} srcMobile={IMGS[k].h5} alt={t(`E_text${img}`)} />
                        <p className="img-text">{t(`E_text${img}`)}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
